import { render, staticRenderFns } from "./EmptyPosition.vue?vue&type=template&id=788efe9a&"
import script from "./EmptyPosition.vue?vue&type=script&lang=js&"
export * from "./EmptyPosition.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports